import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-32 bg-navy relative overflow-hidden" data-id="element-31">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[150px] pointer-events-none" data-id="element-32" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative mb-12 mx-auto w-full max-w-md md:max-w-lg" data-id="element-34">
          <div className="absolute -inset-3 bg-primary/20 rounded-2xl blur-2xl -z-10" data-id="element-35" />
          <div className="relative rounded-2xl overflow-hidden border border-primary/40 shadow-[0_0_50px_rgba(0,180,216,0.25)] bg-navy-deep" data-id="element-36">
            <img src="https://cdn.magicpatterns.com/uploads/nar9gau2t3xo4CbKuxTDDu/IMagen_pagina_Blas_4.jpg" alt="Fundador de CONECKTA listo para tu llamada estratégica" className="w-full h-auto object-contain block" data-id="element-37" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/40 via-transparent to-transparent pointer-events-none" data-id="element-38" />
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight" data-id="element-39">
          ¿Listo Para Convertir Tus Interesados en Clientes Fieles?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-muted leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-40">
          Descubre si CONECKTA es para tu negocio en una llamada estratégica
          gratuita de 15 minutos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col items-center gap-6" data-id="element-41">
          <a href="https://wa.link/cesnp8" target="_blank" rel="noopener noreferrer" className="btn-cta text-lg px-12 py-5 group w-full sm:w-auto" data-id="element-42">
            Agenda Tu Llamada Gratis
            <ArrowRightIcon className="w-6 h-6 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-43" />
          </a>

          <div className="flex items-center gap-2 text-sm text-muted font-medium" data-id="element-44">
            <ShieldCheckIcon className="w-4 h-4 text-primary" data-id="element-45" />
            Sin compromiso · Sin tarjeta de crédito
          </div>
        </motion.div>
      </div>
    </section>;
}